import React from 'react';
import BannerImg from '../../../assets/images/courses/banner_Home.jpg';

const CoursesHero = () => {
  return (
    <section
      className="courses-hero courses-page"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <div className="courses-hero-black-overlay" aria-hidden="true"></div>
      <div className="hero-content">
        <h1 className="hero-title">
          Automatic, Manual <br />
          &amp; Intensive <br />
          <span style={{ color: '#01922f' }}>Driving Courses</span>
        </h1>
      </div>
    </section>
  );
};

export default CoursesHero;
